// import conf from '../../config/vue/config.js';

import callFunction from './api/leanbot_js_api';
/* eslint-disable */

function checkConnectionExperience($query){
    // window.addEventListener("load",function(){
        // console.log($query)
        //delete data when back from map
        // sessionStorage.removeItem("ADDRESS")
        // sessionStorage.removeItem("NDJSON")
        // sessionStorage.removeItem("ROBOTSTATUS")
        // sessionStorage.removeItem("NEXTSTATUS")
        // sessionStorage.removeItem("DIEMTOIDA")
        // sessionStorage.removeItem("DIEMDATDUOC")
    
        // var url_string = window.location.href
        
        // var urlWebVedu = new URL(url_string);
        // var usernameFromURL = urlWebVedu.searchParams.get("username");
    
        // sessionStorage.setItem("USERNAME", $query.username);
    
        // sessionStorage.setItem("LANG",$query.lang)
        // sessionStorage.setItem("USERID",$query.userid)
        // sessionStorage.setItem("CMID",$query.cmid)
        // sessionStorage.setItem("OBJECTNAME","HOCTAP")
        // sessionStorage.setItem("TOTALTIME",$query.totaltime)
        // sessionStorage.setItem("HOATDONG",$query.hoatdong)
        // sessionStorage.setItem("LOAICHAM",$query.loaicham)
        // sessionStorage.setItem("DIEMTOIDA",$query.diem_toida)
        // sessionStorage.setItem("DIEMCANDAT",$query.diemcandat)
    
        const deviceId = sessionStorage.getItem("USERNAME");
        //Get Address----------------------------
       var url =conf.api.thamso_url+"/get?";
        var method="GET";
        var jsonBody = '{"func":"07","body":{' + 
        '"key": '+ '"' + deviceId + '"' +
        '}}';
    
        var jsonRequest = btoa(jsonBody);
        function getAddressDevice(resp){
          // #602: the API answers data: [] when it has no address for this user;
          // reading data[0] then threw a TypeError.
          var row = resp && Array.isArray(resp.data) ? resp.data[0] : undefined;
          if (!row || !row.value) {
            console.warn("No Leanbot address on file for this user (func 07 returned no row)");
            return;
          }
          sessionStorage.setItem("ADDRESS",row.value)
        }
        
        callFunction(url,method,jsonRequest,getAddressDevice);
        
        // digitaltwins-service#609: the device command is sent by the twin server (it holds
        // the device service login and addresses this user's own device); the page no
        // longer reads the shared leanbot_token credential.
        checkConnection()
        //Get Address----------------------------
    // })
        var intervalIDScanConnection
        var intervalScanConnection = 15000
        intervalIDScanConnection = setInterval(function(){checkConnection()}, intervalScanConnection)
    
    function checkConnection(){
        var addressConnect = sessionStorage.getItem("ADDRESS");
        var dataInputGattNotificationPOST = {
            "command": "gatt/notifications",
            "parameters": { 
                "device": `${addressConnect}`, 
                "serviceUUID": "FFE0", 
                "characteristicUUID": "FFE1", 
                "value": "41" 
            }
        }
        fetch('/leanbot-device/command', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataInputGattNotificationPOST),
        })
        .then((responseGattNotificationsPOST) => responseGattNotificationsPOST.json())
        .then((dataOutputGattNotificationsPOST) => {
            console.log('dataOutputGattNotificationsPOST: ' + dataOutputGattNotificationsPOST.id);
            var intervalNotifications = 3000;
            var gattNotificationsGETURL = '/leanbot-device/command/' + encodeURIComponent(String(dataOutputGattNotificationsPOST.id));
            var intervalIDNotifications = setInterval(function(){
                fetch(gattNotificationsGETURL, { method: 'GET', credentials: 'same-origin' })
                .then((responseGattNotificationsGET) => responseGattNotificationsGET.json())
                .then((dataOutputGattNotificationsGET) => {
                    console.log('dataOutputGattNotificationsGETStatus: ' + dataOutputGattNotificationsGET.status);
                    if (dataOutputGattNotificationsGET.status == "Completed") {
                        clearInterval(intervalIDNotifications)
                        clearInterval(intervalIDScanConnection)
                        var afterCheckDeviceVI = document.getElementById("afterCheckDeviceVI")
                        afterCheckDeviceVI.style.display = "block"
                        var beforeCheckDeviceVI = document.getElementById("beforeCheckDeviceVI")
                        beforeCheckDeviceVI.style.display = "none"
                    }
                    else{
                        clearInterval(intervalIDNotifications)
                    }
                })
                .catch((error) => {
                    console.log("Error: ", error);
                })
            }, intervalNotifications)
        })
        .catch((error) =>{
            console.log("Error: ",error);
        })
    }
}


export default checkConnectionExperience
